import { tableToText } from "@/plugins/copy-to-clipboard";

export const install = (app) => {
  const csvHtml = (tableId: string, filename: string) => {
    let text;
    const element = document.getElementById(tableId);
    if (element) {
      text = tableToText(element);
    }

    downloadCSVFile(text, filename);
  };

  app.config.globalProperties.$csvHtml = csvHtml;
  app.provide("csvHtml", csvHtml);
};

function downloadCSVFile(csv, filename) {
  const csvFile = new Blob([csv], { type: "text/csv" });
  const downloadLink = document.createElement("a");
  downloadLink.download = filename;
  downloadLink.href = window.URL.createObjectURL(csvFile);
  downloadLink.style.display = "none";
  document.body.appendChild(downloadLink);
  downloadLink.click();
}
